import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import PromptGenerator from './pages/prompt-generator';
import SavedPrompts from './pages/saved-prompts';
import PricingPlans from './pages/pricing-plans';
import UserAuthentication from './pages/user-authentication';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeLanding />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/prompt-generator" element={<PromptGenerator />} />
        <Route path="/saved-prompts" element={<SavedPrompts />} />
        <Route path="/pricing-plans" element={<PricingPlans />} />
        <Route path="/user-authentication" element={<UserAuthentication />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
